import React from "react";
import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { SectionTitle } from "../../../components/Checkout/SectionTitle";
import { AddressFields } from "../../../components/Checkout/AddressFields";
import { OrderDeliveryAddressFields } from "../../../types/purchaseOrder/Order";
import { ActualizacionDatosFormValues } from "../ActualizacionDatosTypes";

interface DomicilioSeccionProps {
    methods: UseFormReturn<ActualizacionDatosFormValues>;
}

export const DomicilioSeccion: React.FC<DomicilioSeccionProps> = ({ methods }) => {
    const mismoDomicilio = methods.watch("mismoDomicilioInstalacion") ?? true;

    const handleMismoDomicilioChange = (
        _: React.ChangeEvent<HTMLInputElement>,
        checked: boolean,
    ) => {
        methods.setValue("mismoDomicilioInstalacion", checked, { shouldValidate: false });
        if (checked) {
            methods.clearErrors("domicilioInstalacion" as any);
        } else {
            const cpFacturacion = methods.getValues(
                `domicilioFacturacion.${OrderDeliveryAddressFields.ZipCode}` as any,
            );
            if (cpFacturacion) {
                methods.setValue(
                    `domicilioInstalacion.${OrderDeliveryAddressFields.ZipCode}` as any,
                    cpFacturacion,
                    { shouldValidate: false },
                );
            }
        }
    };

    return (
        <Stack mb={2} spacing={2}>
            <Stack>
                <SectionTitle>Domicilio de facturación</SectionTitle>
                <AddressFields
                    control={methods.control}
                    baseName="domicilioFacturacion"
                    setValue={methods.setValue}
                />
                <FormControlLabel
                    sx={{ mt: 1.5 }}
                    control={
                        <Checkbox
                            checked={mismoDomicilio}
                            onChange={handleMismoDomicilioChange}
                            size="small"
                        />
                    }
                    label="¿Mismo domicilio de instalación?"
                />
            </Stack>

            {!mismoDomicilio && (
                <Stack>
                    <SectionTitle>Domicilio de instalación</SectionTitle>
                    <AddressFields
                        control={methods.control}
                        baseName="domicilioInstalacion"
                        showCP={false}
                        setValue={methods.setValue}
                    />
                </Stack>
            )}
        </Stack>
    );
};
